module.exports = __webpack_public_path__ + "img/CHENLI_logo.2356a749.png";